import {
  getDocuments,
  createDocument,
  updateDocument,
  deleteDocument,
  checkDocuments,
} from '../services/documents';
import { TIMEZONE_GMT } from '../services/request';

// just an example of how the requests will work with getDocuments
const getChargePoints = async (
  page,
  size,
  active,
  chargeBoxGroupPk,
  tenantPk,
  searchInput,
  online,
) => {
  let chargePointsUrl = `chargepoints?timeZone=${TIMEZONE_GMT}&page=${page}&size=${size}&active=${active}`;

  if (chargeBoxGroupPk) {
    chargePointsUrl = chargePointsUrl.concat(
      `&chargeBoxGroupPk=${chargeBoxGroupPk}`,
    );
  }

  if (tenantPk) {
    chargePointsUrl = chargePointsUrl.concat(`&tenantPk=${tenantPk}`);
  }

  if (searchInput) {
    chargePointsUrl = chargePointsUrl.concat(`&searchInput=${searchInput}`);
  }

  if (online) {
    chargePointsUrl = chargePointsUrl.concat(`&online=${online}`);
  }

  const data: any = await getDocuments(chargePointsUrl);

  return data;
};

const getPublicAndOwnedChargePoints = async (
  userPk,
  originType = 'MOVE',
): Promise<any> => {
  const data = await getDocuments(`chargepoints?originType=${originType}`);
  return data;
};

const getChargePoint = async (chargeBoxPk) => {
  const data = await getDocuments(`chargepoints/${chargeBoxPk}`);
  return data;
};

const getCurrentChargingUserName = async (connectorPk): Promise<any> => {
  const data = await getDocuments(`chargepoints/connector/${connectorPk}`);
  return data;
};

const createChargePoint = async (chargepoint) => {
  const data = await createDocument(chargepoint, 'chargepoints');
  return data;
};

const checkChargePoint = async () => {
  const data = await checkDocuments('chargepoints');
  return data;
};

const updateChargePoint = async (chargepoint, chargeBoxPk) => {
  const data = await updateDocument(chargeBoxPk, chargepoint, 'chargepoints');
  return data;
};

const updateConnector = async (connectorForm, connectorId, chargeBoxPk) => {
  const data = await updateDocument(
    `${chargeBoxPk}/connector/${connectorId}`,
    connectorForm,
    'chargepoints',
  );
  return data;
};

const deleteChargePoint = async (chargeBoxPk) => {
  const data = await deleteDocument(chargeBoxPk, 'chargepoints');
  return data;
};

const getPhotos = async (chargeBoxId) => {
  const data = await getDocuments(`chargepoints/${chargeBoxId}/photos`);
  return data;
};

export {
  getChargePoints,
  getChargePoint,
  createChargePoint,
  updateChargePoint,
  getPublicAndOwnedChargePoints,
  updateConnector,
  deleteChargePoint,
  getPhotos,
  checkChargePoint,
  getCurrentChargingUserName,
};
